import React from "react";

import auth from "./Auth";

const hasPermission = ({
  permissions,

  scopes,
}: {
  permissions: any;

  scopes: any;
}) => {
  const scopesMap: any = {};

  scopes?.forEach((scope: any) => {
    scopesMap[scope] = true;
  });

  return permissions?.some((permission: any) => scopesMap[permission]);
};

interface IPermissionsGate {
  errorProps?: any;

  scopes: string[];
}

export default class PermissionsGate extends React.Component<IPermissionsGate> {
  public render() {
    var token = auth.getPermissions();

    if (token && token !== "{}") {
      let permissions: any = [];

      token?.authorization?.permissions?.map((permission: any) => {
        permissions.push(permission.rsname);

        permission?.scopes?.map((scope: any) => {
          permissions.push(scope);
        });
      });

      const permissionGranted = hasPermission({
        permissions,
        scopes: this.props.scopes,
      });

      if (!permissionGranted && !this.props.errorProps) return <></>;
    }

    return <>{this.props.children}</>;
  }
}

